import { Outlet } from "react-router-dom";

const DealerIntakeLayout = () => {
  return (
    <main
      className={
        "min-h-screen h-full flex text-sm overflow-hidden w-screen !font-[Inter]"
      }
    >
      <div
        className="flex-grow border-l border-solid border-neutral-300 bg-neutral-200 flex flex-col justify-top items-center py-4"
        role="main"
      >
        <Outlet />
      </div>
    </main>
  );
};

export { DealerIntakeLayout };
